module.exports = __webpack_public_path__ + "img/winner.f4f6ba98.webp";